<template>
  <section>
      <section>
          <section v-show="step == 1">
            <div class="view__header">
                <div class="container text-center mx-auto">
                    <h4 class="view__header--text">Booking Summary</h4>
                    <div class="notification-header mt-4 d-flex justify-content-center">
                        <p class="notification-text">Price may increase if you book later.</p>
                    </div>
                </div>
            </div>
            <section class="tab__section my-5">
                <div class="row">
                    <div class="col-lg-7 right-side animated fadeIn">
                        <div class="d-flex">
                            <img src="@/assets/TAJimages/hotels/hotel-bg.png" alt="hotel-bg" width="300px" class="img-bg img-fluid">
                            <div class="ml-4">
                                <p class="hotel-name mb-5">St Christopher’s Inn Hammersmith</p>
                                <p>Star Rating</p>
                                <div class="d-flex align-items-center">
                                    <p class="hotel-rating-count">0/5</p>
                                    <p class="hotel-rating pl-2">Excellent</p>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <p class="room-spec">18-BED MIXED DORMITORY SHARED BATHROOM ROOM ONLY</p>
                        <div class="d-flex justify-content-between">
                            <p class="number-rooms">Number of rooms</p>
                            <p class="number-rooms">2</p>
                        </div>
                        <div class="d-flex justify-content-between">
                            <p class="number-rooms">Maximum occupancy</p>
                            <p class="number-rooms">2</p>
                        </div>
                        <hr>
                        <div class="d-flex justify-content-between">
                            <div>
                                <p class="check-in">Check - In</p>
                                <p class="check-date">Nov 20, 2021</p>
                            </div>
                            <div>
                                <p class="check-in">Check - Out</p>
                                <p class="check-date">Nov 23, 2021</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-5 animated fadeIn">
                        <div class="fare-summary text-white p-4">
                            <h5>Fare Summary</h5>
                            <div class="line-1"></div>
                            <div class="d-flex justify-content-between">
                                <div class="traveler-text">
                                    <h5>Rooms/Guests</h5>
                                    <h6>2 Rooms x 3 night(s)</h6>
                                </div>
                                <h5 class="trav-amount">N2,000</h5>
                            </div>
                            <div class="line-2"></div>
                            <div class="d-flex justify-content-between">
                                <h6 class="trav-amount">Total</h6>
                                <h6 class="trav-amount">N2000</h6>
                            </div>
                            <div class="line-2"></div>
                            <p class="sub-text">*Refundable (Penalty Applies).</p>
                            <p class="sub-text" style="width:300px">*Total fare displayed above has been rounded off and may thus show a slight difference.</p>
                            <div class="text-center mt-5">
                                <button class="btn btn-primary py-2" @click="step++">Continue Booking</button>
                            </div>
                            <div class="text-center mt-2">
                                <router-link to="/lifestyle/hotel/hotel">
                                    <button type="button" class="btn btn-outline-none text-white">Go Back</button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </section>
        <!-- input details section -->
        <section v-show="step == 2" class="px-4 details-section animated fadeIn">
            <div class="row">
                <div class="col-lg-7 offset-lg-2">
                    <div class="continue-booking border-sm">
                        <div v-show="isOtpPage == 1">
                            <h5 class="py-3 text-center payment-header">Payment</h5>
                            <hr class="my-0">
                            <div class="form-group p-5">
                                <label for="surname" class="form-label">Select From Account <span class="text-danger">*</span></label>
                                <select v-model="submitForm.accountNumber" placeholder="Select From Account *" class="form-control" required="required">
                                    <option value="">Select From Account *</option>
                                    <option v-for="account in userAccounts" :value="account.accountNumber" :key="account.id">{{account.accountNumber}} (Acct No: {{account.accountName}} | Balance: {{account.availableBalance}})</option>
                                </select>
                                <div class="form-group mt-4">
                                    <label for="pin" class="form-label">Transaction Pin <span class="text-danger">*</span></label>
                                    <input @keypress="isNumber" v-model="submitForm.transactionPin" class="form-control" placeholder="Enter Transaction Pin *" maxlength="4" :type="type"/>
                                      <span @click="showPin" class="pull-right show-pin">{{type === 'password' ? 'show' : 'hide'}}</span>
                                </div>
                                <div class="mt-5 d-flex justify-content-center align-items-center text-center">
                                    <p @click="step--" class="text-danger mr-5 mb-0 font-weight-bold" style="cursor:pointer">Back</p>
                                    <button type="button" :disabled="loading" @click="isOtpPage++" class="btn btn-danger">
                                        <div v-if="loading">Please wait...</div> 
                                        <div v-else>Pay for Hotel</div>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-show="isOtpPage == 2" class="animated fadeIn px-5 py-5 text-center succes-page">
                            <img src="@/assets/TAJimages/hotels/hotel-success.svg" alt="">
                            <h6>Hotel booked successfully!</h6>
                            <p>Thanks for banking with us.</p>
                            <button type="button" @click="exitPage" class="btn btn-danger">Exit</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
      </section>
      <div v-if="isLoading" class="loader-12"></div>
  </section>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import moment from 'moment';
  export default {
    filters: {
      moment: function (date) {
        return moment(date).format('HH:MM');
      },
      momentDate: function (date) {
        return moment(date).format('DD MMM, YYYY');
      }
    },
    data:() => ({
      tabItems: 'itinerary',
      step: 1,
      isOtpPage: 1,
      showMemberPromo: false,
      showCorporatePromo: false,
      isLoading: false,
      passengerDetails: [],
      bookingItemModels: [],
      form: {
        title: '',
        passengerType: '',
        firstName: '',
        lastName: '',
        middleName: '',
        dateOfBirth: '',
        age: '',
        phoneNumber: '',
        address: '',
        passportNumber: '',
        expiryDate: '',
        email: '',
        gender: '',
        city: '',
        country: '',
        postalCode: '',
      },
      bookingDetails: {
        bookingId: '',
        targetCurrency: 'NGN',
        bookingData: '',
        productType: 'Flight',
      },
      checked: false,
      loading: false,
      submitForm: {
        accountNumber: '',
        pnrNumber: '',
        bookingId: '',
        appPlatform: 1,
        transactionReference: '',
        transactionPin: '',
      },
      type: 'password',
    }),
    computed: {
      ...mapState('flight', ['selectedFlight']),
      ...mapState({
        account: state => state.dashboard.dashboardData,
      }),
      userAccounts(){
        return this.account ? this.account.accounts : null;
      },
      routeId() {
        return this.$route.params.id;
      },
    },
    async mounted() {
    //   const data = {
    //     selectData: this.routeId,
    //     targetCurrency: 'NGN',
    //     appPlatform: 1,
    //   };
    //   this.isLoading = true;
    //   try {
    //     await this.getSelectedFlight(data);
    //     this.isLoading = false;
    //   } catch (error) {
    //     this.isLoading = false;
    //     this.$swal({
    //       title: 'Oops...',
    //       text: error.response.data.errors[0],
    //       type: 'error',
    //       confirmButtonText: 'Ok',
    //     });
    //   }
    },
    methods: {
      ...mapActions('flight', ['getSelectedFlight', 'bookFlight', 'payForFlight']),
      showPin() {
        this.type = this.type === 'password' ? 'text' : 'password';
      },
      switchTab(tab) {
        this.tabItems = tab;
      },
      showDropdown(type) {
        switch (type) {
        case 'memberPromo':
          this.showMemberPromo = !this.showMemberPromo;
          break;
        case 'corporatePromo':
          this.showCorporatePromo =  !this.showCorporatePromo;
          break;
        }
      },
      async continueBooking() {
        this.bookingDetails.bookingId = this.selectedFlight.bookingId;
        this.bookingDetails.bookingData = this.selectedFlight.selectData;
        this.form.passengerType = this.getFlightPriceDetails[0].passengerType;
        this.form.age = parseInt(this.form.age);
        this.passengerDetails.push(this.form);
        this.bookingItemModels.push(this.bookingDetails);
        if(this.passengerDetails.length > 1) {
          this.passengerDetails.splice(0, this.passengerDetails.length - 1);
        }
        if(this.bookingItemModels.length > 1) {
          this.bookingItemModels.splice(0, this.bookingItemModels.length - 1);
        }
        const data = {
          passengerDetails: this.passengerDetails,
          bookingItemModels: this.bookingItemModels,
          bookingId: this.selectedFlight.bookingId,
        };
        if(this.checked) {
          this.loading = true;
          try {
            const response = await this.bookFlight(data);
            this.loading = false;
            this.step++;
            const details = response.data.flightBookingResult.flightBookingSummaryModel;
            this.submitForm.pnrNumber = details.pnrReferenceNumber;
            this.submitForm.bookingId = response.data.bookingId;
          } catch (error) {
            this.loading = false;
            this.$swal({
              title: 'Oops...',
              text: error.response.data.errors[0],
              type: 'error',
              confirmButtonText: 'Ok',
            });
          }
        } else {
          this.$swal({
            title: 'Oops...',
            text: 'Please agree to the terms and conditions',
            type: 'error',
            confirmButtonText: 'Ok',
          });
        }
      },
      generateUUID() {
        // generate unique id
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = (d + Math.random()*16)%16 | 0;
          d = Math.floor(d/16);
          return (c==='x' ? r : (r&0x3|0x8)).toString(16);
        });
        this.submitForm.transactionReference = uuid;
        return uuid;
      },
      async submitHotelPayment() {
        this.generateUUID();
        if(this.submitForm.accountNumber === '' || this.submitForm.transactionPin === '') {
          this.$swal({
            title: 'Oops...',
            text: 'Please fill in all the fields',
            type: 'error',
            confirmButtonText: 'Ok',
          });
        } else {
          this.loading = true;
          try {
            await this.payForFlight(this.submitForm);
            this.loading = false;
            this.isOtpPage++;
          } catch (error) {
            this.loading = false;
            this.$swal({
              title: 'Oops...',
              text: error.response.data.errors[0],
              type: 'error',
              confirmButtonText: 'Ok',
            });
          }
        }
      },
      exitPage() {
        this.$router.push({
          name: 'hotel',
        });
        window.location.reload();
      },
    }
  };
</script>

<style scoped>
.search-body {
  height: 100%;
  padding: 0 30px;
  margin: 0;
  background-color: #EAF0F3;
}
.view__header {
    background: #EAF0F3;
    height: 100%;
    padding-top: 40px;
    padding-bottom: 10px;
}
.view__header--text {
    letter-spacing: 0px;
    color: #232949;
    opacity: 1;
    font-weight: bold;
    font-size: 15px;
}
.notification-header {
    padding: 10px;
    background: #FFF0E4 0% 0% no-repeat padding-box;
    border-radius: 5px;
    opacity: 1;
    margin: 0 auto;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    width: 789px;
}
.notification-text {
    letter-spacing: 0.3px;
    color: #000000;
    opacity: 1;
    margin-bottom: 0;
}
.tab-section {
    height: 42px;
    background: #E1ECF3 0% 0% no-repeat padding-box;
    opacity: 1;
}
.tab-items {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    width: 350px;
    margin: 0 auto;
    cursor: pointer;
}
.tab-items h5 {
    letter-spacing: 0.36px;
    color: #223344;
    opacity: 1;
    font-size: 16px;
    font-weight: 500;
}
.tab-items h5:last-child {
    color: #818F9B;
}
.tab__section {
    padding: 10px 50px;
}
.right-side {
    height: 500px;
    overflow: scroll;
}
.right-side-form {
    height: 700px;
    overflow: scroll;
}
.line {
    height: 1px;
    background: #E1ECF3;
    border: 1px dotted #E1ECF3;
    width: 90%;
    margin: 10px 0px;
}
.line-1 {
    height: 0.5px;
    background: #E1ECF3;
    border: 0.5px solid #6D757D;
    margin: 20px 0px;
}
.line-2 {
    height: 0.5px;
    background: #E1ECF3;
    border: 0.5px solid #E1ECF3;
    margin: 20px 0px;
}
.departure-header {
    letter-spacing: 0.4px;
    color: #1F1F1F;
    opacity: 1;
    font-size: 18px;
    font-weight: bold;
}
.fare-summary {
    width: 375px;
    height: 100%;
    background: #223344 0% 0% no-repeat padding-box;
    opacity: 1;
    /* position: fixed; */
}
.flight-luggage {
    background: #FDF9EC 0% 0% no-repeat padding-box;
    border-radius: 5px;
    opacity: 1;
    padding: 20px;
    width: 90%;
}
.flight-luggage p {
    letter-spacing: 0.34px;
    color: #223344;
    opacity: 1;
    font-size: 15px;
}
.flight-about-date {
    letter-spacing: 0.34px;
    color: #818F9B;
    opacity: 1;
    font-size: 14px;
    font-weight: normal;
}
.airport-name {
    letter-spacing: 0.36px;
    color: #223344;
    opacity: 1;
    font-size: 15px;
    font-weight: normal;
    width: 387px;
}
.flight-type {
    letter-spacing: 0.3px;
    color: #818F9B;
    opacity: 1;
    font-size: 13px;
    font-weight: normal;
}
.flight-time {
    letter-spacing: 0.34px;
    color: #1F1F1F;
    opacity: 1;
    font-size: 16px;
}
.traveler-text h5,
.trav-amount {
    letter-spacing: 0px;
    color: #FFFFFF;
    opacity: 1;
    font-size: 18px;
    font-weight: bold;
}
.traveler-text h6 {
    letter-spacing: 0px;
    color: #FFFFFF;
    opacity: 1;
    font-size: 14px;
    font-weight: normal;
}
.rules h6 {
    letter-spacing: 0.36px;
    color: #3A4248;
    opacity: 1;
    font-size: 18px;
}
.rules p {
    letter-spacing: 0.24px;
    color: #3A4248;
    opacity: 1;
    font-size: 13px;
    font-weight: normal;
}
.sub-text {
    letter-spacing: 0px;
    color: #FFFFFF;
    opacity: 1;
    font-size: 14px;
}
.continue-booking {
    background: #FFFFFF;
    opacity: 1;
}
.booking-header h5 {
    letter-spacing: 0px;
    color: #1F1F1F;
    opacity: 1;
    font-size: 17px;
    font-weight: bold;
}
.booking-notification-header {
    background: #F2F2FF 0% 0% no-repeat padding-box;
    border-radius: 5px;
    opacity: 1;
    padding: 10px 15px;
}
.booking-notification-text {
    letter-spacing: 0.3px;
    color: #6569B5;
    opacity: 1;
    margin-bottom: 0;
    font-size: 11px;
}
.booking-pass-text {
    letter-spacing: 0px;
    color: #1F1F1F;
    opacity: 1;
    font-size: 16px;
}
.fa-angle-down {
    cursor: pointer;
}
input::placeholder,
textarea::placeholder,
option {
    font-size: 14px;
    color: #ACACAC;
    font-weight: 400;
}
.p-text {
    letter-spacing: 0.28px;
    color: #223344;
    opacity: 1;
    font-size: 14px;
    margin-bottom: 4px;
    font-weight: bold;
}
.sub-p-text {
    letter-spacing: 0.28px;
    color: #6D8494;
    opacity: 1;
    font-weight: normal;
    font-size: 13px;
    margin-bottom: 4px;
}
.arrives-text {
    letter-spacing: 0.28px;
    font-size: 13px;
    margin-bottom: 0;
    color: #E41613;
}
.total-sec h5 {
    letter-spacing: 0px;
    color: #6D8494;
    opacity: 1;
    font-size: 18px;
}
.total-sec h6 {
    letter-spacing: 0px;
    color: #223344;
    opacity: 1;
    font-size: 18px;
}
.footer-sec {
    background: #FFF0E4;
    padding: 15px 20px;
    text-align: center;
    color: #223344;
    opacity: 1;
}
.footer-sec p {
    letter-spacing: 0px;
    color: #223344;
    opacity: 1;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 0;
}
.details-section {
    /* padding: 40rem 0; */
    padding-top: 5rem;
}
.payment-header {
    letter-spacing: 0px;
    color: #1F1F1F;
    opacity: 1;
    margin-bottom: 0;
    font-size: 18px;
}
.border-sm {
    border-radius: 7px;
}
.otpPage p {
    letter-spacing: -0.18px;
    color: #000000;
    opacity: 1;
    font-size: 14px;
}
.otpPage h6 {
    letter-spacing: 0px;
    color: #232949;
    opacity: 1;
    font-size: 18px;
}
.succes-page h6 {
    letter-spacing: 0px;
    color: #232949;
    opacity: 1;
    font-size: 18px;
    margin-top: 50px;
}
.succes-page p {
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    font-size: 14px;
    margin-top: 30px;
    margin-bottom: 60px;
}
.active-border {
    border-bottom: 2px solid #F58220;
}
.show-pin {
  font-size: 12px;
  color: #E41613;
  cursor: pointer;
}
.img-bg {
    border-radius: 10px;
}
.hotel-rating-count {
  background: #F58220;
  border-radius: 5px;
  padding: 8px;
  color: #fff;
  text-align: center;
  width: 50px;
  letter-spacing: 0;
  font-size: 14px;
}
.hotel-rating {
  font-size: 20px;
  color: #223344;
  letter-spacing: 0;
}
.hotel-name {
    letter-spacing: 0;
    font-size: 14px;
    color: #1F1F1F;
    font-weight: bold;
}
.room-spec {
    font-size: 15px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #1F1F1F;
    opacity: 1;
    margin: 0;
    width: 300px;
    margin-bottom: 20px;
}
.number-rooms {
    font-size: 17px;
    font-weight: normal;
    letter-spacing: 0px;
    color: #6D8494;
    opacity: 1;
    margin: 0;
    margin-bottom: 10px;
}
.check-in {
    font-size: 19px;
    font-weight: normal;
    letter-spacing: 0px;
    color: #6D8494;
    opacity: 1;
    margin: 0;
    margin-top: 10px;
}
.check-date {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #223344;
    opacity: 1;
    margin: 0;
}
</style>